import { globalStyle, style, styleVariants } from '../layer.css.ts';
import { white } from '../palette.ts';
import { spinner } from '../spinner/spinner.css.ts';
import { finePointerHover } from '../theme-v2/fine-pointer-hover.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { borderRadius, fonts, space } from '../tokens';
import { typography } from '../typography';

export const inputV2Container = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s12,
  width: '100%',
  minHeight: 42,
  padding: `${space.s8}px ${space.s16}px`,
  borderRadius: borderRadius.r8,
  backgroundColor: '#16171a',
  boxShadow: hairline(white[50]),
  color: themeV2.color.text.quaternary,
  fontFamily: fonts.sans,
  '@media': {
    [finePointerHover]: {
      selectors: {
        '&:hover:not([data-disabled]):not(:focus-within)': {
          boxShadow: hairline(themeV2.color.border.hover),
        },
      },
    },
  },
  selectors: {
    '&:focus-within, &:active:not([data-disabled])': {
      boxShadow: hairline(white[900]),
    },
    '&[data-disabled]': {
      pointerEvents: 'none',
      color: themeV2.color.text.disabled,
    },
  },
});

export const inputV2Sizes = styleVariants({
  default: {},
  compact: {
    minHeight: 36,
  },
});

export type InputV2Size = keyof typeof inputV2Sizes;

globalStyle(`.${inputV2Container} :where(svg)`, {
  width: 20,
  height: 20,
  flexShrink: 0,
});

export const searchInputV2Lead = style({
  position: 'relative',
  display: 'block',
  flexShrink: 0,
  width: 20,
  height: 20,
});

export const searchInputV2LeadHidden = style({
  visibility: 'hidden',
});

globalStyle(`.${searchInputV2Lead} > .${spinner}`, {
  position: 'absolute',
  inset: 0,
  margin: 0,
  boxSizing: 'border-box',
});

export const inputV2 = style({
  ...typography.bodyMd,
  appearance: 'none',
  flex: 1,
  minWidth: 0,
  margin: 0,
  padding: 0,
  border: 0,
  background: 'none',
  color: themeV2.color.text.primary,
  fontFamily: fonts.sans,
  outline: 'none',
  selectors: {
    '&::placeholder': {
      color: themeV2.color.text.quaternary,
    },
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    '&:disabled::placeholder': {
      color: themeV2.color.text.disabled,
    },
  },
});

export const inputV2Clear = style({
  appearance: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 0,
  padding: 0,
  border: 0,
  background: 'none',
  color: 'inherit',
  cursor: 'pointer',
  '@media': {
    [finePointerHover]: {
      selectors: {
        '&:hover:not(:disabled)': {
          color: themeV2.color.text.primary,
        },
      },
    },
  },
  selectors: {
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: `2px solid ${themeV2.color.border.focus}`,
      outlineOffset: 2,
    },
  },
});
